import DOMPurify from "dompurify";

const BLOG_HTML_ALLOWED = {
  ALLOWED_TAGS: [
    "p", "br", "h2", "h3", "strong", "em", "u", "ol", "ul", "li", "a",
  ],
  ALLOWED_ATTR: ["href", "target", "rel"],
};

export function isHtmlBlogContent(text) {
  const s = String(text || "").trim();
  if (!s.startsWith("<")) return false;
  return /<\/[a-z][\s\S]*>/i.test(s);
}

export function plainTextParagraphs(text) {
  return String(text || "")
    .split(/\n\n+/)
    .map((p) => p.trim())
    .filter(Boolean);
}

export function sanitizeBlogHtml(html) {
  return DOMPurify.sanitize(String(html || ""), BLOG_HTML_ALLOWED);
}
